let compiledFilters = { };
let encodedFilters = { };

let apiFilterFunctions = {

  valueExists(list, value) {
    return list.find(val => val == value);
  },

  processRecordLayout(filterItem, topKey, parentKey, accumulator, includeList, fieldList) {
    const saveAccumulator = accumulator;
    let realName = null;
    for (let key in filterItem) {
      if (key && key != 'filterName' && key != 'postProcess') {
        accumulator = saveAccumulator;
        if (filterItem[key].real_name){
          realName = filterItem[key].real_name;
        }
        if (key == topKey) {
          this.processRecordLayout(filterItem[key], topKey, realName ? realName : topKey, accumulator, includeList, fieldList);
        }
        else if (key == 'record_fields') {
          if (parentKey) {
            if (!fieldList[parentKey]) {
              fieldList[parentKey] = Object.assign([], filterItem[key]);
            }
            else {
              fieldList[parentKey] = Object.assign (fieldList[parentKey], filterItem[key]);
            }
          }
        }
        else {
          if (key != topKey && key != 'record_name' && key != 'real_name') {
            let record_name = filterItem[key].record_name ? filterItem[key].record_name : key;
            accumulator = accumulator ? (accumulator + '.' + record_name) : record_name;
            if (accumulator) {
              if (!this.valueExists(includeList, accumulator)) {
                includeList.push(accumulator);
              }
            }
            if (parentKey) {
              if (fieldList[parentKey] && !this.valueExists(fieldList[parentKey], record_name)) {
                fieldList[parentKey].push(record_name);
              }
            }
            this.processRecordLayout(filterItem[key], topKey, realName ? realName : key, accumulator, includeList, fieldList);
          }
        }
      }
    } 
  },

  getRecordLayout(filter) {
    if (filter) {
      let topKey = null;
      for (let key in filter) {
        if (key && key != 'filterName') {
          topKey = key;
          break;
        }
      }
      if (!compiledFilters[filter.filterName]) {
        let includeList = [];
        let fieldsList = {};
        this.processRecordLayout(filter, topKey, topKey, '', includeList, fieldsList);
        compiledFilters[filter.filterName] = { include: includeList, fields: fieldsList };
      }
      return compiledFilters[filter.filterName];
    }
  },

  getEncodedRecordLayout(filter) {
    if (filter) {
      if (!encodedFilters[filter.filterName]) {
        encodedFilters[filter.filterName] = encodeURI(JSON.stringify(this.getRecordLayout(filter)));
      }
      return encodedFilters[filter.filterName];
    }
  },
  
  trimNullEntries(item) {
    if (Array.isArray(item)) {
      item = item.filter(i => {
        if (i) {
          return true;
        }
        else {
          return false;
        }
      });
      item = item.map(i => {
        i = this.trimNullEntries(i);
        return i;
      });
    }
    else {
      for (let key in item) {
        if (key) {
          if (item[key] == null || item[key] == undefined) {
            delete item[key];
          }
          else {
            if (Array.isArray(item[key])) {
              item[key] = this.trimNullEntries(item[key]);
            }
          }
        }
      }
    }
    return item;
  },
};

export const user_collection_complete = {
  record_name: 'users',
  record_fields: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type', 'profile_image'],
  company: {
    record_name: 'companies',
    record_fields: ['id', 'name'],
  },

  company_vendor_user_collection_complete: {
    record_name: 'company_vendor_users',
    record_fields: ['id', 'vendor_user'],
    company: {
      record_name: 'company',
      record_fields: ['id', 'name'],
    },
  },

  postProcess(record) {
    return record;
  },
};

export const user_complete = {
  record_name: 'users',
  record_fields: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type', 'profile_image'],
  company: {
    record_name: 'companies',
    record_fields: ['id', 'name', 'logo'],
  },
  company_vendor_user_collection_complete: {
    record_name: 'company_vendor_users',
    record_fields: ['id', 'vendor_user'],
    company: {
      record_name: 'company',
      record_fields: ['id', 'name'],
    },
  },
  role: {
    record_fields: ['id', 'name'],
  },

  postProcess(record) {
    return record;
  },
};

export const user_complete_with_company_logo = {
  record_name: 'users',
  record_fields: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type', 'profile_image'],
  company: {
    record_name: 'companies',
    record_fields: ['id', 'name', 'logo'],
  },
  company_vendor_user_collection_complete: {
    record_name: 'company_vendor_users',
    record_fields: ['id', 'vendor_user'],
    company: {
      record_name: 'company',
      record_fields: ['id', 'name', 'logo'],
    },
  },
  role: {
    record_fields: ['id', 'name'],
  },

  postProcess(record) {
    return record;
  },
};

export const comment_user_complete = {
  record_name: 'user',
  record_fields: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type', 'profile_image'],
  company: {
    record_name: 'companies',
    record_fields: ['id', 'name'],
  },
  company_vendor_user_collection_complete: {
    record_name: 'company_vendor_users',
    record_fields: ['id', 'vendor_user'],
    company: {
      record_name: 'company',
      record_fields: ['id', 'name'],
    },
  },
  role: {
    record_fields: ['id', 'name'],
  },

  postProcess(record) {
    return record;
  },
};

export const user_partial = {
  record_fields: ['id', 'name', 'first_name', 'last_name', 'profile_image'],
  role: {
    record_fields: ['id', 'name'],
  },

  postProcess(record) {
    return record;
  },
};

export const user_minimal = {
  record_fields: ['id', 'name', 'first_name', 'last_name', 'profile_image'],

  postProcess(record) {
    return record;
  },
};

export const user_collection_partial = {
  record_name: 'users',
  record_fields: ['id', 'name', 'first_name', 'last_name', 'profile_image'],
  role: {
    record_fields: ['id', 'name'],
  },
  company: {
    record_name: 'companies',
    record_fields: ['id', 'name'],
  },

  postProcess(record) {
    return record;
  },
};

export const company_partial = {
  record_name: 'company',
  record_fields: ['id', 'name'],

  postProcess(record) {
    return record;
  },
};

export const company_collection_partial = {
  record_name: 'companies',
  record_fields: ['id', 'name'],

  postProcess(record) {
    return record;
  },
};

export const attachment_collection_complete = {
  record_name: 'attachments',
  record_fields: ['id', 'name', 'notes', 'upload', 'attachable_type', 'attachable_id', 'upload_updated_at', 'upload',
    'photo_latitude', 'photo_longitude', 'photo_taken_at'],
  user: user_partial,

  postProcess(record) {
    return record;
  },
};

export const document_collection_complete = {
  record_name: 'documents',
  record_fields: ['id', 'name', 'notes', 'upload', 'attachable_type', 'attachable_id', 'upload_updated_at', 'upload'],
  user: user_partial,

  postProcess(record) {
    return record;
  },
};

export const document_collection_shallow = {
  record_name: 'documents',
  real_name: 'attachment',
  record_fields: ['id', 'name', 'notes', 'upload', 'attachable_type', 'attachable_id', 'upload_updated_at', 'upload', 'completion_name'],
  user: user_minimal,

  postProcess(record) {
    return record;
  },
};

export const event_history_collection_complete = {
  record_name: 'event_histories',
  record_fields: ['id', 'body', 'event_type', 'created_at', 'type', 'sub_type'],
  user_who_performed_action: user_minimal,
  activity: {
    record_name: 'activities',
    record_fields: ['id', 'name'],
  },
  activity_sub_type: {
    record_name: 'activity_sub_types',
    record_fields: ['id', 'name'],
  },

  postProcess(record) {
    return record;
  },
};

export const comment_collection_complete = {
  record_name: 'comments',
  record_fields: ['id', 'user_id', 'body', 'caption', 'created_at', 'commentable_type', 'commentable_id'],
  user: comment_user_complete,

  postProcess(record) {
    return record;
  },
};

export const user_task_assigment_collection_complete = {
  record_name: 'user_task_assignments',
  record_fields: ['id', 'user_id', 'task_id', 'assignment_type', 'user', 'created_at'],
  user: user_complete,

  postProcess(record) {
    return record;
  },
};

export const user_task_assigment_collection_partial = {
  record_name: 'user_task_assignments',
  record_fields: ['id', 'user_id', 'task_id', 'assignment_type', 'user', 'created_at', 'user'],
  user: user_complete,

  postProcess(record) {
    return record;
  },
};

export const location_user_collection_complete = {
  record_name: 'location_users',
  record_fields: ['id', 'location_id', 'user', 'user_id', 'title'],
  user: user_complete,

  postProcess(record) {
    return record;
  },
};

export const location_user_collection_complete_2 = {
  record_name: 'location_users',
  record_fields: ['id', 'location_id', 'user', 'user_id', 'title'],
  user: user_partial,

  postProcess(record) {
    return record;
  },
};

export const market_collection_complete = {
  record_name: 'markets',
  record_fields: ['id', 'name', 'code'],

  postProcess(record) {
    return record;
  },
};

export const market_complete = {
  record_name: 'market',
  record_fields: ['id', 'name', 'code'],

  postProcess(record) {
    return record;
  },
};

export const location_complete = {
  record_name: 'location',
  record_fields: ['id', 'name', 'latitude', 'longitude', 'address', 'city', 'state', 'zip', 'guid', 'notes'],
  market: market_complete,
  location_user: location_user_collection_complete,

  postProcess(record) {
    return record;
  },
};

export const location_complete_2 = {
  record_name: 'location',
  record_fields: ['id', 'name', 'latitude', 'longitude', 'address', 'city', 'state', 'zip', 'guid', 'notes'],
  market: market_complete,
  location_user: location_user_collection_complete_2,

  postProcess(record) {
    return record;
  },
};

export const location_collection_complete = {

  filterName: 'location_collection_complete',
  location: {
    record_name: 'locations',
    record_fields: ['id', 'name', 'latitude', 'longitude', 'address', 'city', 'state', 'zip', 'guid', 'notes'],
    market: market_complete,
    location_user: location_user_collection_complete,
  },

  postProcess(record) {
    return record;
  },
};

export const project_minimal = {
  record_name: 'project',
  record_fields: ['id', 'name', 'guid', 'status'],
  company: company_partial,

  postProcess(record) {
    return record;
  },
};

export const completion_criterion_collection_minimal = {
  record_name: 'completion_criteria',
  record_fields: ['id', 'task_id', 'name', 'instructions', 'order', 'reviewed_at', 'approved_at', 'rejected_at', 'completed_at', 'completion_type',
    'not_applicable', 'response', 'status', 'requested_file_type'],
  
  postProcess(record) {
    return record;
  },
};

export const completion_criterion_collection_complete = {
  record_name: 'completion_criteria',
  record_fields: ['id', 'task_id', 'name', 'instructions', 'order', 'reviewed_at', 'approved_at', 'rejected_at', 'completed_at', 'completion_type',
    'not_applicable', 'response', 'status', 'requested_file_type'],
  attachment: attachment_collection_complete,
  comment: comment_collection_complete,
  event_history: event_history_collection_complete,

  postProcess(record) {
    return record;
  },
};

export const completion_criterion_collection_favorites_complete = {
  record_name: 'completion_criteria',
  record_fields: ['id', 'task_id', 'name', 'instructions', 'order', 'reviewed_at', 'approved_at', 'rejected_at', 'completed_at', 'completion_type',
    'not_applicable', 'response', 'status', 'requested_file_type'],
  attachment: attachment_collection_complete,
  comment: comment_collection_complete,

  postProcess(record) {
    return record;
  },
};

export const inventory_item_collection_complete = {
  record_name: 'inventory_items',
  record_fields: ['id', 'inventory_id', 'identifier', 'customer_data', 'user_id'],
  inventory: {
    record_name: 'inventory',
    record_fields: ['id', 'company_id', 'name', 'customer_data'],
  },

  postProcess(record) {
    return record;
  },
};

export const closeout_collection_complete = {
  record_name: 'closeouts',
  record_fields: ['id', 'name', 'closeoutable_type', 'closeoutable_id', 'duration', 'size', 'status', 'key', 'expiring_url', 'created_at', 'updated_at'],
  user: user_minimal,

  postProcess(record) {
    return record;
  },
};

export const reference_document_collection_complete = {
  record_name: 'reference_documents',
  record_fields: ['id', 'name', 'user_id', 'company_id', 'group_identifier', 'attachment', 'attachment_file_name', 'attachment_content_type', 'attachment_file_size', 'attachment_updated_at'],

  postProcess(record) {
    return record;
  },
};

export const project_manager_complete = {
  record_fields: ['id', 'first_name', 'last_name', 'email', 'title', 'assignment_type'],
  role: {
    record_fields: ['id', 'name'],
  },

  postProcess(record) {
    return record;
  },
};

export const project_type_partial = {
  record_name: 'project_type',
  record_fields: ['id', 'name'],

  postProcess(record) {
    return record;
  },
};

export const project_user_collection_complete = {
  record_name: 'project_users',
  record_fields: ['id', 'user_id', 'assignment_type', 'created_at'],
  user: user_complete,

  postProcess(record) {
    return record;
  },
};

export const project_user_collection_complete_2 = {
  record_name: 'project_users',
  record_fields: ['id', 'user_id', 'assignment_type', 'created_at'],
  user: user_partial,

  postProcess(record) {
    return record;
  },
};

/**********************
 * Tasks
 *********************/

export const task_collection_complete = {
  filterName: 'task_collection_complete',
  task: {
    record_name: 'tasks',
    record_fields: ['id', 'name', 'notes', 'order', 'due_date', 'status', 'guid', 'notify_after_complete', 'complete_in_order', 'documentation_required',
      'completion_percentage', 'order', 'task_attachments_count', 'build_id', 'project_id', 'completion_criteria_counts', 'build_owners'],
    project: project_minimal,
    completion_criterion: completion_criterion_collection_complete,
    user_task_assignment: user_task_assigment_collection_complete,
    reference_document: reference_document_collection_complete,
  },

  postProcess(record) {
    return record;
  },
};

/** Same as above, but not top-level */
export const child_task_collection_complete = {
  record_name: 'tasks',
  record_fields: ['id', 'name', 'notes', 'order', 'due_date', 'status', 'guid', 'notify_after_complete', 'complete_in_order', 'documentation_required',
    'completion_percentage', 'order', 'task_attachments_count', 'build_id', 'project_id', 'completion_criteria_counts', 'build_owners'],
  completion_criterion: completion_criterion_collection_complete,
  user_task_assignment: user_task_assigment_collection_complete,
  reference_document: reference_document_collection_complete,

  postProcess(record) {
    return record;
  },
};

export const tasks_for_builds = {
  record_name: 'tasks',
  record_fields: ['id', 'name', 'notes', 'order', 'due_date', 'status', 'guid', 'notify_after_complete', 'complete_in_order', 'documentation_required',
    'completion_percentage', 'order', 'task_attachments_count', 'build_id', 'project_id', 'completion_criteria_counts', 'build_owners'],
  user_task_assignment: user_task_assigment_collection_complete,

  postProcess(record) {
    return record;
  },
};

export const tasks_for_template_builds = {
  record_name: 'tasks',
  record_fields: ['id', 'name', 'notes', 'order', 'due_date', 'status', 'guid', 'notify_after_complete', 'complete_in_order', 'documentation_required',
    'order', 'task_attachments_count', 'build_id', 'project_id', 'completion_criteria_counts'],

  postProcess(record) {
    return record;
  },
};

export const child_task_collection_for_tempate = {
  record_name: 'tasks',
  record_fields: ['id', 'name', 'notes', 'order', 'due_date', 'status', 'guid', 'notify_after_complete', 'complete_in_order', 'documentation_required',
    'completion_percentage', 'order', 'task_attachments_count', 'build_id', 'project_id', 'completion_criteria_counts', 'build_owners'],
  reference_document: reference_document_collection_complete,

  postProcess(record) {
    return record;
  },
};

export const sorted_task_collection = {
  record_name: 'sorted_tasks',
  record_fields: ['id', 'name', 'notes', 'order', 'due_date', 'status', 'guid', 'notify_after_complete', 'complete_in_order', 'documentation_required',
    'completion_percentage', 'order', 'task_attachments_count', 'build_id', 'project_id', 'completion_criteria_counts', 'build_owners'],
  reference_document: reference_document_collection_complete,
  completion_criterion: completion_criterion_collection_minimal,
  postProcess(record) {
    return record;
  },
};

export const task_favorites_collection_complete = {
  record_name: 'tasks',
  record_fields: ['id', 'name', 'notes', 'order', 'due_date', 'status', 'guid', 'notify_after_complete', 'complete_in_order', 'documentation_required',
    'completion_percentage', 'order', 'task_attachments_count', 'build_id', 'project_id', 'build_owners'],
  project: project_minimal,
  completion_criterion: completion_criterion_collection_favorites_complete,
  user_task_assignment: user_task_assigment_collection_complete,
  inventory_item: inventory_item_collection_complete,
  reference_document: reference_document_collection_complete,

  postProcess(record) {
    return record;
  },
};

export const task_complete = {
  filterName: 'task_complete',
  task: {
    record_name: 'tasks',
    record_fields: ['id', 'name', 'notes', 'order', 'due_date', 'status', 'guid', 'notify_after_complete', 'complete_in_order', 'documentation_required',
      'completion_percentage', 'order', 'task_attachments_count', 'build_id', 'project_id', 'completion_criteria_counts', 'build_owners'],
    project: project_minimal,
    completion_criterion: completion_criterion_collection_complete,
    user_task_assignment: user_task_assigment_collection_complete,
    reference_document: reference_document_collection_complete,
    inventory_item: inventory_item_collection_complete,
    eventy_history: event_history_collection_complete,
  },

  postProcess(record) {
    return record;
  },
};

export const task_collection_partial = {
  filterName: 'task_collection_partial',
  task: {
    record_name: 'tasks',
    record_fields: ['id', 'name', 'notes', 'order', 'due_date', 'status', 'guid', 'notify_after_complete', 'complete_in_order', 'documentation_required',
      'completion_percentage', 'order', 'task_attachments_count', 'build_id', 'project_id', 'build_owners'],
    project: project_minimal,
    user_task_assignment: user_task_assigment_collection_complete,
    completion_criterion: completion_criterion_collection_minimal,
  },

  postProcess(record) {
    return record;
  },
};

export const task_for_template = {
  record_name: 'tasks',
  record_fields: ['id', 'name', 'notes', 'order', 'due_date', 'status', 'guid', 'notify_after_complete', 'complete_in_order', 'documentation_required',
      'task_attachments_count'],

  postProcess(record) {
    return record;
  },
};

export const task_collection_minimal= {
  record_name: 'tasks',
  record_fields: ['id', 'name', 'notes', 'order', 'due_date', 'status', 'guid', 'notify_after_complete', 'complete_in_order', 'documentation_required',
    'completion_percentage', 'order', 'task_attachments_count', 'build_id', 'project_id', 'build_owners'],

  postProcess(record) {
    return record;
  },
};

/**********************
 * Builds
 *********************/

export const user_build_assignment_collection_complete = {
  record_name: 'user_build_assignments',
  record_fields: ['id', 'user_id', 'build_id', 'assignment_type', 'user', 'created_at', 'profile_image'],
  user: user_complete_with_company_logo,

  postProcess(record) {
    return record;
  },
};

export const builds_with_builds = {
  record_name: 'builds',
  record_fields: ['id', 'name', 'builds', 'completion_percentage', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry',
    'buildable_type', 'buildable_id'],
  user_build_assignment: user_build_assignment_collection_complete,
  build: {
    record_name: 'builds',
    record_fields: ['id', 'name', 'builds', 'completion_percentage', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry',
      'buildable_type', 'buildable_id'],
    build: { record_name: 'builds' },
  },
  postProcess(record) {
    return record;
  },
};

export const ac_builds_expanded = {
  filterName: 'ac_builds_expanded',
  parentbuild: {
    real_name: 'build',
    record_name: 'builds',
    record_fields: ['id', 'name', 'builds', 'completion_percentage', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry',
      'buildable_type', 'buildable_id'],
    user_build_assignment: user_build_assignment_collection_complete,
    build: {
      record_name: 'builds',
      record_fields: ['id', 'name', 'builds', 'completion_percentage', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry',
        'buildable_type', 'buildable_id'],
      build: { record_name: 'builds' },
    },
  },
  postProcess(record) {
    return record;
  },
};

export const ac_builds_simple = {
  filterName: 'ac_builds_expanded',
  parentbuild: {
    real_name: 'build',
    record_name: 'builds',
    record_fields: ['id', 'name', 'builds', 'completion_percentage', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry',
      'buildable_type', 'buildable_id'],
    user_build_assignment: user_build_assignment_collection_complete,
  },
  postProcess(record) {
    return record;
  },
};

export const builds_with_builds_for_template = {
  record_name: 'builds',
  record_fields: ['id', 'name', 'builds', 'tasks_count', 'builds_count', 'order', 'ancestry',
    'buildable_type', 'buildable_id'],
  build: {
    record_name: 'builds',
    record_fields: ['id', 'name', 'builds', 'tasks_count', 'builds_count',  'order', 'ancestry',
      'buildable_type', 'buildable_id'],
    build: { record_name: 'builds' },
  },
  postProcess(record) {
    return record;
  },
};

/** "all_builds" tells the api to fetch all builds under the project, including sub-builds */
export const all_builds_collection_complete = {
  record_name: 'builds',
  record_fields: ['id', 'name', 'builds', 'completion_percentage', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry',
    'buildable_type', 'buildable_id'],
  user_build_assignment: user_build_assignment_collection_complete,
  task: child_task_collection_complete,
  build: {
    record_name: 'builds',
    record_fields: ['id', 'name', 'builds', 'completion_percentage', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry',
    'buildable_type', 'buildable_id'],
    task: child_task_collection_complete,
    build: { record_name: 'builds' },
  },

  postProcess(record) {
    return record;
  },
};

export const build_with_tasks = {
  filterName: 'build_with_tasks',
  parentbuild: {
    real_name: 'build',
    record_name: 'builds',
    record_fields: ['id', 'name', 'completion_percentage', 'builds', 'tasks', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry', 'buildable_type', 'buildable_id', 'builds'],
    task: tasks_for_builds,
    user_build_assignment: user_build_assignment_collection_complete,
    
    build: {
      record_name: 'builds',
      record_fields: ['id', 'name', 'completion_percentage', 'builds', 'tasks', 'tasks_count', 'builds_count', 'tasks_completed_count', 'order', 'ancestry',
      'buildable_type', 'buildable_id'],
      task: tasks_for_builds,
      build: { record_name: 'builds' },
    },
  },

  postProcess(record) {
    record.builds = record.builds.filter(build => {
      if (build.ancestry) {
        let levels = build.ancestry.split('/');
        if (levels.length <= 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    });
    return record;
  },
};

export const build_with_tasks_for_template = {
  filterName: 'build_with_tasks_for_template',
  parentbuild: {
    real_name: 'build',
    record_name: 'builds',
    record_fields: ['id', 'name', 'builds', 'tasks', 'tasks_count', 'builds_count', 'order', 'ancestry', 'buildable_type', 'buildable_id', 'builds'],
    task: tasks_for_template_builds,
    
    build: {
      record_name: 'builds',
      record_fields: ['id', 'name', 'builds', 'tasks', 'tasks_count', 'builds_count', 'order', 'ancestry',
      'buildable_type', 'buildable_id'],
      task: tasks_for_builds,
      build: { record_name: 'builds' },
    },
  },

  postProcess(record) {
    record.builds = record.builds.filter(build => {
      if (build.ancestry) {
        let levels = build.ancestry.split('/');
        if (levels.length <= 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    });
    return record;
  },
};

/**********************
 * Project Types & Templates
 *********************/

export const project_template_partial = {
  record_name: 'project_template',
  record_fields: ['id', 'name', 'guid', 'tasks_count', 'builds_count', 'archived_at', 'root_build_id', 'version', 'group_identifier', 'published_at', 'num_versions'],

  postProcess(record) {
    return record;
  },
};

export const project_template = {
  record_name: 'project_templates',
  record_fields: ['id', 'name', 'guid', 'tasks_count', 'builds_count', 'archived_at', 'root_build_id', 'notes', 'version', 'group_identifier', 'published_at', 'num_versions'],
  company: company_partial,
  markets: market_collection_complete,
  company_closeout_template: {
    record_name: 'company_closeout_templates',
    record_fields: ['id', 'closeout_template_id', 'name'],
    company: company_partial,
  },

  postProcess(record) {
    return record;
  },
};

export const project_template_with_builds = {
  filterName: 'project_tempate_with_builds',
  project_template: {
    record_name: 'project_templates',
    record_fields: ['id', 'name', 'guid', 'tasks_count', 'builds_count', 'archived_at', 'root_build_id', 'notes', 'version', 'group_identifier', 'published_at', 'num_versions'],
    company: company_partial,
    build: builds_with_builds_for_template,
    markets: market_collection_complete,
    project_type: project_type_partial,
    company_closeout_template: {
      record_name: 'company_closeout_template',
      record_fields: ['id', 'closeout_template_id', 'name'],
      company: company_partial,
    },
  },

  postProcess(record) {
    record.builds = record.builds ? record.builds.filter(build => {
      if (build.ancestry) {
        let levels = build.ancestry.split('/');
        if (levels.length <= 1) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    }) : [];
    return record;
  },
};

export const project_template_with_builds_and_tasks = {
  filterName: 'project_tempate_with_builds_and_tasks',
  project_template: {
    record_name: 'project_templates',
    record_fields: ['id', 'name', 'guid', 'tasks_count', 'builds_count', 'archived_at', 'root_build_id', 'notes', 'version', 'group_identifier', 'published_at', 'num_versions'],
    company: company_partial,
    build: build_with_tasks_for_template.parentbuild,
    markets: market_collection_complete,
    project_type: project_type_partial,
    company_closeout_template: {
      record_name: 'company_closeout_template',
      record_fields: ['id', 'closeout_template_id', 'name'],
      company: company_partial,
    },
  },

  postProcess(record) {
    record.builds = record.builds ? record.builds.filter(build => {
      if (build.ancestry) {
        let levels = build.ancestry.split('/');
        if (levels.length <= 1) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    }) : [];
    return record;
  },
};

export const project_type_with_templates = {
  filterName: 'project_type_with_templates',
  project_type: {
    record_name: 'project_types',
    record_fields: ['id', 'name'],
    project_template: project_template,
  },

  postProcess(record) {
    return record;
  },
};
export const project_type_nav = {
  filterName: 'project_type_nav',
  project_type: {
    record_name: 'project_types',
    record_fields: ['id', 'name', 'archived_at', 'root_build_id'],
  },

  postProcess(record) {
    return record;
  },
};

/**********************
 * Project Embeds
 *********************/

/**********************
 * Projects
 *********************/

export const project_partial = {
  filterName: 'project_partial',
  project: {
    record_name: 'projects',
    record_fields: ['id', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'created_at', 'archived_at', 'status', 'root_build_id', 'is_favorite'],
    project_manager: project_manager_complete,
    project_type: project_type_partial,
    location: location_complete,
    company: company_partial,
    project_user: project_user_collection_complete,
    user: user_complete,
  },

  postProcess(record) {
    return record;
  },
};

export const project_partial_2 = {
  filterName: 'project_partial_2',
  project: {
    record_name: 'projects',
    record_fields: ['id', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'archived_at', 'status', 'root_build_id', 'is_favorite'],
    project_manager: project_manager_complete,
    project_type: project_type_partial,
    location: location_complete_2,
    company: company_partial,
    project_user: project_user_collection_complete_2,
    user: user_complete,
  },

  postProcess(record) {
    return record;
  },
};

export const project_with_builds = {
  filterName: 'project_with_builds',
  project: {
    record_name: 'projects',
    record_fields: ['id', 'name', 'guid', 'tasks_count', 'builds', 'tasks_completed_count', 'created_at', 'archived_at', 'status', 'root_build_id', 'is_favorite', 'notes'],
    project_manager: project_manager_complete,
    project_type: project_type_partial,
    project_template: project_template_partial,
    location: location_complete,
    company: company_partial,
    build: builds_with_builds,
    project_user: project_user_collection_complete,
    user: user_complete,
    custom_project_setting: {
      record_name: 'custom_project_settings',
      record_fields: ['id', 'project_id', 'notes', 'setting_label', 'setting_type', 'text_value', 'float_value',
        'integer_value', 'boolean_value', 'weather_value', 'selection_value', 'value_instance_guid', 'field_required', 'units', 'min_value', 'max_value'],
    },
  },

  postProcess(record) {
    record.builds = record.builds ? record.builds.filter(build => {
      if (build.ancestry) {
        let levels = build.ancestry.split('/');
        if (levels.length <= 1) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    }) : [];
    return record;
  },
};

export const project_nav_collection = {
  filterName: 'project_nav_collection',
  project: {
    record_name: 'projects',
    record_fields: ['id', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'created_at', 'archived_at', 'status', 'root_build_id', 'is_favorite', 'notes'],
    location: location_complete,
    project_type: project_type_partial,
    project_template: project_template_partial,
  },

  postProcess(record) {
    return record;
  },
};

export const project_nav_collection_2 = {
  filterName: 'project_nav_collection',
  project: {
    record_name: 'projects',
    record_fields: ['id', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'archived_at', 'status', 'root_build_id', 'is_favorite', 'notes'],
    location: location_complete_2,
  },

  postProcess(record) {
    return record;
  },
};

export const location_project_collection = {
  filterName: 'location_project_collection',
  project: {
    record_name: 'projects',
    record_fields: ['id', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'created_at', 'archived_at', 'status', 'location_id', 'root_build_id', 'is_favorite', 'notes'],
    project_manager: project_manager_complete,
    document: document_collection_complete,
    closeout: closeout_collection_complete,
    location: location_complete,
    build_closeout: {
      record_name: 'build_closeouts',
      record_fields: ['id', 'name', 'closeoutable_type', 'closeoutable_id', 'duration', 'size', 'status', 'key', 'expiring_url', 'created_at', 'updated_at'],
      user: user_minimal,
    },
    task_closeout: {
      record_name: 'task_closeouts',
      record_fields: ['id', 'name', 'closeoutable_type', 'closeoutable_id', 'duration', 'size', 'status', 'key', 'expiring_url', 'created_at', 'updated_at'],
      user: user_minimal,
    },
  },

  processProject(project) {
    // This will always be an empty array and causes problems.
    if (project.builds) {
      delete project.builds;
    }
    if (project.project_users) {
      delete project.project_users;
    }
    if (project.users){
      delete project.users;
    }
    if (project.documents && project.documents.length > 0) {
      project.documents = project.documents.map(document => {
        if (document.data && document.data.attributes) {
          return document.data.attributes;
        }
        else {
          return document;
        }
      });
    }
    if (project.build_closeouts && project.build_closeouts.length > 0) {
      if (!project.closeouts) {
        project.closeouts = [];
      }
      for (let i = 0; i < project.build_closeouts.length; i++){
        project.closeouts.push(project.build_closeouts[i]);
      }
      delete project.build_closeouts;
    }
    if (project.task_closeouts && project.task_closeouts.length > 0) {
      if (!project.closeouts) {
        project.closeouts = [];
      }
      for (let i = 0; i < project.task_closeouts.length; i++){
        project.closeouts.push(project.task_closeouts[i]);
      }
      delete project.task_closeouts;
    }
    if (project.closeouts && project.closeouts.length) {    
      project.closeouts.sort((c1, c2) => {
        if (c1.created_at < c2.created_at) {
          return 1;
        }
        else if (c1.created_at > c2.created_at) {
          return -1;
        }
        else {
          return 0;
        }
      });
    }
    return project;
  },

  postProcess(record) {
    if (record.length) {
      record = record.map(project => {
        return this.processProject(project);
      });
      return record;
    }
    else {
      return this.processProject(record);
    }
  },
};

export const location_project_collection_shallow = {
  filterName: 'location_project_collection_shallow',
  project: {
    record_name: 'projects',
    record_fields: ['id', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'created_at', 'archived_at', 'status', 'location_id', 'root_build_id', 'is_favorite', 'notes', 'documents'],
    closeout: closeout_collection_complete,
    document: document_collection_shallow,
  },

  processProject(project) {
    // This will always be an empty array and causes problems.
    if (project.builds) {
      delete project.builds;
    }
    if (project.project_users) {
      delete project.project_users;
    }
    if (project.users){
      delete project.users;
    }
    if (project.documents && project.documents.length > 0) {
      project.documents = project.documents.map(document => {
        if (document.data && document.data.attributes) {
          return document.data.attributes;
        }
        else {
          return document;
        }
      });
    }
    if (project.closeouts && project.closeouts.length) {    
      project.closeouts.sort((c1, c2) => {
        if (c1.created_at < c2.created_at) {
          return 1;
        }
        else if (c1.created_at > c2.created_at) {
          return -1;
        }
        else {
          return 0;
        }
      });
    }
    return project;
  },

  postProcess(record) {
    if (record.length) {
      record = record.map(project => {
        return this.processProject(project);
      });
      return record;
    }
    else {
      return this.processProject(record);
    }
  },
};

export const project_with_tasks = {
  filterName: 'project_with_tasks',
  project: {
    record_name: 'projects',
    record_fields: ['id', 'builds', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'created_at', 'archived_at', 'status', 'root_build_id', 'is_favorite', 'notes'],
    project_manager: project_manager_complete,
    location: location_complete,
    company: company_partial,
    project_user: project_user_collection_complete,
    user: user_complete,
    task: child_task_collection_complete,
  },

  postProcess(record) {
    return record;
  },
};

export const bulk_assign_projects = {
  filterName: 'bulk_assign_projects',
  project: {
    record_name: 'projects',
    record_fields: ['id', 'builds', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'created_at', 'archived_at', 'status', 'root_build_id', 'is_favorite', 'notes'],
    project_manager: project_manager_complete,
    project_type: project_type_partial,
    project_template: project_template_partial,
    task: tasks_for_builds,
  },

  postProcess(record) {
    return record;
  },
};

export const project_with_builds_and_tasks = {
  filterName: 'project_with_builds_and_tasks',
  project: {
    record_name: 'projects',
    record_fields: ['id', 'builds', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'created_at', 'archived_at', 'status', 'root_build_id', 'is_favorite', 'notes'],
    project_manager: project_manager_complete,
    project_type: project_type_partial,
    project_template: project_template_partial,
    location: location_complete,
    company: company_partial,
    build: all_builds_collection_complete,
    project_user: project_user_collection_complete,
    user: user_complete,
    custom_project_setting: {
      record_name: 'custom_project_settings',
      record_fields: ['id', 'project_id', 'notes', 'setting_label', 'setting_type', 'text_value', 'float_value',
        'integer_value', 'boolean_value', 'weather_value', 'selection_value', 'value_instance_guid', 'field_required', 'units', 'min_value', 'max_value'],
    },
    task: child_task_collection_complete,
  },

  postProcess(record) {
    return record;
  },
};

export const project_complete = {
  filterName: 'project_complete',
  project: {
    record_name: 'projects',
    record_fields: ['id', 'builds', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'created_at', 'archived_at', 'status', 'root_build_id', 'is_favorite', 'notes'],
    project_manager: project_manager_complete,
    project_type: project_type_partial,
    project_template: project_template_partial,
    location: location_complete,
    company: company_partial,
    build: all_builds_collection_complete,
    project_user: project_user_collection_complete,
    user: user_collection_complete,
    custom_project_setting: {
      record_name: 'custom_project_settings',
      record_fields: ['id', 'project_id', 'notes', 'setting_label', 'setting_type', 'text_value', 'float_value',
        'integer_value', 'boolean_value', 'weather_value', 'selection_value', 'value_instance_guid', 'field_required', 'units', 'min_value', 'max_value'],
    },
    task: child_task_collection_complete,
  },

  postProcess(record) {
    return record;
  },
};

export const company_complete = {
  filterName: 'company_complete',
  company: {
    record_name: 'companies',
    record_fields: ['id', 'name'],
    users: user_collection_partial,
  },

  postProcess(record) {
    return record;
  },
};

export const project_favorites_collection = {
  filterName: 'project_favorites_collection',
  project: {
    record_name: 'projects',
    record_fields: ['id', 'name', 'guid', 'tasks_count', 'tasks_completed_count', 'created_at', 'archived_at', 'status', 'root_build_id', 'is_favorite', 'notes'],
    project_manager: project_manager_complete,
    location: location_complete,
    company: company_partial,
    project_user: project_user_collection_complete,
    user: user_collection_partial,
    task: task_favorites_collection_complete,
  },

  postProcess(record) {
    return record;
  },
};

export default apiFilterFunctions;



// WEBPACK FOOTER //
// ./src/helpers/apiRecordLayoutFunctions.js